import { useCallback } from 'react';

import { useConfigSlice } from '../store/slices/config/selectors';
import { URLUtilities } from '../utils/url';
import { getWindowObject } from '../utils/window';

interface IRedirectMessage {
  tableType: string;
  urlMap: object;
}

export const useGameRedirectConnected = (): ((message: IRedirectMessage) => void) => {
  const env = useConfigSlice.env();
  const playerUI = env?.playerUI;
  const redirectOrigin = getWindowObject();

  return useCallback(
    (message: IRedirectMessage) => {
      if (!playerUI) {
        return;
      }
      const redirectUrl = URLUtilities.combine(playerUI, `${message.tableType}/`);

      Object.entries(message.urlMap).forEach(([key, value]) => {
        redirectUrl.searchParams.set(key, value as string);
      });

      redirectUrl.searchParams.set('timeStamp', Date.now().toString());

      redirectOrigin.open(redirectUrl.toString(), '_self');
    },
    [playerUI, redirectOrigin]
  );
};
